import { updateProjectQuestionsDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateProjectQuestionCallable = getCallable(
  updateProjectQuestionsDefinition,
);
